const convertToNoDecimalValue = (data : string) => {
    return parseFloat(data).toFixed(0);
}

export default convertToNoDecimalValue;